"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_arrow_light_left_style_1 = __importDefault(require("./uicon.arrow.light.left.style"));
class UiconArrowLightLeft extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { d: "M11.5862 15.9288L23.6863 3.82872C24.1046 3.41034 24.1046 2.73206 23.6863 2.31369C23.2678 1.89544 22.5896 1.89544 22.1712 2.31369L9.31369 15.1712C8.89544 15.5896 8.89544 16.2679 9.31369 16.6863L22.1712 29.5438C22.5969 29.9549 23.2752 29.9431 23.6863 29.5175C24.0872 29.1022 24.0872 28.444 23.6863 28.0288L11.5862 15.9288Z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconArrowLightLeft.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconArrowLightLeft.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_arrow_light_left_style_1.default)(UiconArrowLightLeft);
//# sourceMappingURL=uicon.arrow.light.left.js.map